import {
  ITonneCreateBody,
  ITonneDefektResponseBody,
} from "../../store/slices/tonneDefect";
import { adminInstance, instance } from "../api";

const getViersenTonneDeffektStreetsAndPlaces = () => {
  return instance
    .get<{
      places: {
        id: string;
        gemeindeBezeichnung: string;
        gemeindePostleitzahl: number;
        gemeindeNummer: number;
      }[];
      streets: {
        id: string;
        gemeindeNummer: number;
        strasseBezeichnung: string;
      }[];
    }>("tonne-defekt/data")
    .then((res) => res.data);
};

const createTonneDefekt = (data: ITonneCreateBody) => {
  return instance
    .post<{
      error?: boolean;
      errorMessage?: string;
    }>("/tonne-defekt", data)
    .then((res) => res.data);
};

const getAdminTonneDeffekt = ({
  direction,
  page,
  pageSize,
  searchValue,
  sort,
  signal,
  startDate,
  endDate,
  status,
  type,
}: {
  sort?: string;
  direction?: string;
  searchValue?: string;
  page?: number;
  pageSize?: number;
  signal: AbortSignal;
  startDate?: Date | null | string;
  endDate?: Date | null | string;
  status?: string[];
  type?: string[];
}) => {
  return adminInstance
    .get<{
      totalCount: number;
      data: ITonneDefektResponseBody[];
    }>("/admin/tonne-defekt", {
      params: {
        direction,
        page,
        pageSize,
        searchValue,
        sort,
        startDate,
        endDate,
        status,
        type,
      },
      signal,
    })
    .then((res) => res.data);
};

const changeItemsStatuses = ({
  ids,
  status,
}: {
  ids: string[];
  status: string;
}) => {
  return adminInstance
    .put<ITonneDefektResponseBody[]>(`/admin/tonne-defekt/status`, {
      status,
      ids,
    })
    .then((res) => res.data);
};

const getAdminTonneDeffektItemById = (id: string) => {
  return adminInstance
    .get<ITonneDefektResponseBody>(`/admin/tonne-defekt/${id}`)
    .then((res) => res.data);
};

const updateStatusById = ({
  id,
  status,
  message,
}: {
  id: string;
  status: string;
  message?: string;
}) => {
  return adminInstance
    .put<ITonneDefektResponseBody>(`/admin/tonne-defekt/${id}/status`, {
      status,
      message,
    })
    .then((res) => res.data);
};

const TonneDefekt = {
  get: {
    getViersenTonneDeffektStreetsAndPlaces,
    getAdminTonneDeffekt,
    getAdminTonneDeffektItemById,
  },
  post: {
    createTonneDefekt,
  },
  put: {
    changeItemsStatuses,
    updateStatusById,
  },
};

export default TonneDefekt;
